// 099 D04 流量：GA4 未接入诚实态 + DB 业务事件日序列 + 采集清单
import { useState } from "react";
import { ops } from "../../lib/api";
import { useOpsQuery } from "./useOpsQuery";
import { Bar, DaySeg, Note, Sect } from "./widgets";

export default function Traffic() {
  const [days, setDays] = useState(7);
  const q = useOpsQuery(() => ops.traffic(days), [days]);

  if (q.loading && !q.data) return <p className="muted">加载中…</p>;
  if (q.forbidden) return <p>🔒 {q.forbidden}</p>;
  if (q.error) return <p style={{ color: "var(--err)" }}>加载失败：{q.error}</p>;
  if (!q.data) return null;
  const d = q.data;
  const maxDay = Math.max(1, ...d.businessDaily.map((r) => Math.max(r.signups, r.projects, r.jobs)));

  return (
    <>
      <h2 className="d-title">网站流量</h2>
      <p className="d-sub2">访问分析未接入；业务事实以数据库为准</p>

      <div className="d-filter">
        <DaySeg days={days} onChange={setDays} />
        <span className="d-tz">时区 {d.range.timezone}</span>
        <span className="d-updated">更新于 <b>{new Date(d.range.updatedAt).toLocaleString("zh-CN", { timeZone: "Asia/Shanghai", hour12: false })}</b></span>
      </div>

      <div className="d-alert">
        ⚠ <span><b>访问分析未接入（GA4 未配置）</b>：{d.analytics.note}。接入后本页展示访问用户/PV/来源渠道/设备地区；接入日之前的流量不补造。</span>
      </div>

      <Sect title="业务事件日序列（数据库事实）" tag="D04" hint="非访问量：注册/建项目/发起生成/完成" />
      <div className="d-tblwrap">
        <table>
          <thead><tr><th>日期</th><th className="num">新增注册</th><th className="num">新建项目</th><th className="num">发起生成</th><th className="num">完成</th><th>量级</th></tr></thead>
          <tbody>
            {[...d.businessDaily].reverse().map((r) => (
              <tr key={r.date}>
                <td>{r.date}</td>
                <td className="num">{r.signups}</td>
                <td className="num">{r.projects}</td>
                <td className="num">{r.jobs}</td>
                <td className="num">{r.done}</td>
                <td><Bar pct={(Math.max(r.signups, r.projects, r.jobs) / maxDay) * 100} kind="c" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Sect title="业务事件采集清单" hint="注册/生成成功以服务端业务事实为准，按钮点击 ≠ 完成" />
      <div className="d-tblwrap">
        <table>
          <thead><tr><th>事件</th><th>触发点</th><th>状态</th><th className="num">范围内计数</th></tr></thead>
          <tbody>
            {d.events.map((e) => (
              <tr key={e.key}>
                <td><code>{e.key}</code> · {e.name}</td>
                <td>{e.source ?? "—"}</td>
                <td>{e.collected ? <span className="tag t-green">服务端事实</span> : <span className="tag t-yellow">未采集</span>}</td>
                <td className="num">{e.count ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Note>
        隐私约束（D04⑤）：未来接入埋点时，事件载荷不含邮箱、姓名、项目名称、输入原文、上传内容、提示词或签名 URL；
        下载率等客户端事件未埋点前一律显示「未采集」。
      </Note>
    </>
  );
}
